import DataInForm from './index-content.json';


export default class ToolFormLoader {

    // -------------------------------------------------------------
    // Properties

    public formData: any = DataInForm;

}
